import { BALANCE } from '../config/balance';
import type { DamageSource } from '../core/types';

/** 敌方弹道：远程吐弹 / Boss 弹幕，直线飞行，限时回收。 */
export interface FoeBolt {
  active: boolean;
  x: number;
  y: number;
  prevX: number;
  prevY: number;
  vx: number;
  vy: number;
  damage: number;
  radius: number;
  life: number;
  source: DamageSource;
}

const MAX_LIFE = 6;

export function createFoeBolt(): FoeBolt {
  return {
    active: false,
    x: 0, y: 0, prevX: 0, prevY: 0,
    vx: 0, vy: 0, damage: 0, radius: 7,
    life: 0,
    source: { type: 'spit', enemyId: -1 },
  };
}

export interface SpawnFoeOpts {
  x: number;
  y: number;
  angle: number;
  speed: number;
  damage: number;
  radius: number;
  source: DamageSource;
}

export function spawnFoeBolt(pool: { obtain(): FoeBolt }, o: SpawnFoeOpts): FoeBolt {
  const b = pool.obtain();
  b.active = true;
  b.x = o.x; b.y = o.y;
  b.prevX = o.x; b.prevY = o.y;
  b.vx = Math.cos(o.angle) * o.speed;
  b.vy = Math.sin(o.angle) * o.speed;
  b.damage = o.damage;
  b.radius = o.radius;
  b.life = MAX_LIFE;
  b.source = o.source;
  return b;
}

/** 移动与寿命；返回 false 表示到期回收。 */
export function updateFoeBolt(b: FoeBolt, dt: number): boolean {
  b.prevX = b.x;
  b.prevY = b.y;
  b.x += b.vx * dt;
  b.y += b.vy * dt;
  b.life -= dt;
  return b.life > 0;
}

/** 命中玩家判定（半径和）。 */
export function foeBoltHits(b: FoeBolt, px: number, py: number): boolean {
  const rr = b.radius + BALANCE.player.radius;
  const dx = b.x - px;
  const dy = b.y - py;
  return dx * dx + dy * dy <= rr * rr;
}
